export default {
  title: {
    edit: 'Update the sector',
    create: 'Create a new sector',
  },
  form: {
    name: 'Label',
    climbingType: 'Climbing type',
    climbingTypes: {
      route: 'Route',
      boulder: 'Boulder',
    },
    gradeRange: 'Grade range',
    floorPlan: 'Floor plan',
    floorPlanUpload: 'Upload an image',
    floorPlanProject: 'Open the floor plan editor',
    floorPlanProjectDialog: {
      title: 'Floor plan editor',
      submit: 'Apply',
    },
    submit: 'Save',
  },
  formHelper: {
    climbingType: 'The climbing type determines the grade scale that will be applied to the routes and comments',
    gradeRange: 'Simplify the forms for routes and comments by limiting the spectrum of possible grades on the sector',
    floorPlan: 'The floor plan of the sector is an image that is displayed on under the routes and allows climbers to locate the route',
  },
  tooltip: {
    last_sector: 'At least one sector required',
  },
  delete: {
    button: 'Delete this sector',
    confirm: {
      title: 'Please confirm the deletion of the "{{name}}" sector',
      warning_one: 'One route in this sector',
      warning_other: '{{count}} routes in this sector',
      helper: "By deleting this sector, you'll also delete the related routes.",
      submit: 'Delete',
    },
  },
}
